import { ISelectOption } from './selectOption.interface';
import { FilterTypesEnum } from '../filters/filterTypes.enum';

export const AuditLogObjectTypeOptions: ISelectOption[] = [
  {
    id: 'access_group',
    value: 'Access Group',
    displayName: 'Access Group',
    filterType: FilterTypesEnum.ResourceType,
    categoryName: FilterTypesEnum.ResourceType,
  },
  {
    id: 'add_domain',
    value: 'Add Domain',
    displayName: 'Add Domain',
    filterType: FilterTypesEnum.ResourceType,
    categoryName: FilterTypesEnum.ResourceType,
  },
  {
    id: 'agent_step',
    value: 'Agent Step',
    displayName: 'Agent Step',
    filterType: FilterTypesEnum.ResourceType,
    categoryName: FilterTypesEnum.ResourceType,
  },
  {
    id: 'apikey',
    value: 'APIKey',
    displayName: 'APIKey',
    filterType: FilterTypesEnum.ResourceType,
    categoryName: FilterTypesEnum.ResourceType,
  },
  {
    id: 'integration',
    value: 'Integration',
    displayName: 'Integration',
    filterType: FilterTypesEnum.ResourceType,
    categoryName: FilterTypesEnum.ResourceType,
  },
  {
    id: 'label_binding',
    value: 'Label Binding',
    displayName: 'Label Binding',
    filterType: FilterTypesEnum.ResourceType,
    categoryName: FilterTypesEnum.ResourceType,
  },
  {
    id: 'list_resource_permission',
    value: 'List Resource Permission',
    displayName: 'List Resource Permission',
    filterType: FilterTypesEnum.ResourceType,
    categoryName: FilterTypesEnum.ResourceType,
  },
  {
    id: 'playbook',
    value: 'Playbook',
    displayName: 'Playbook',
    filterType: FilterTypesEnum.ResourceType,
    categoryName: FilterTypesEnum.ResourceType,
  },
  {
    id: 'policy',
    value: 'Policy',
    displayName: 'Policy',
    filterType: FilterTypesEnum.ResourceType,
    categoryName: FilterTypesEnum.ResourceType,
  },
  {
    id: 'resource',
    value: 'Resource',
    displayName: 'Resource',
    filterType: FilterTypesEnum.ResourceType,
    categoryName: FilterTypesEnum.ResourceType,
  },
  {
    id: 'role',
    value: 'Role',
    displayName: 'Role',
    filterType: FilterTypesEnum.ResourceType,
    categoryName: FilterTypesEnum.ResourceType,
  },
  {
    id: 'rule',
    value: 'Rule',
    displayName: 'Rule',
    filterType: FilterTypesEnum.ResourceType,
    categoryName: FilterTypesEnum.ResourceType,
  },
  {
    id: 'user',
    value: 'User',
    displayName: 'User',
    filterType: FilterTypesEnum.ResourceType,
    categoryName: FilterTypesEnum.ResourceType,
  },
  {
    id: 'violation',
    value: 'Violation',
    displayName: 'Violation',
    filterType: FilterTypesEnum.ResourceType,
    categoryName: FilterTypesEnum.ResourceType,
  },
  {
    id: 'finding',
    value: 'Finding',
    displayName: 'Finding',
    filterType: FilterTypesEnum.ResourceType,
    categoryName: FilterTypesEnum.ResourceType,
  },
].sort((a, b) => a.displayName.localeCompare(b.displayName));
